import React from "react";
import { View, StyleSheet, ViewStyle, StyleProp } from "react-native";
import { useTheme } from "~/styles/theme";

interface DividerProps {
  style?: StyleProp<ViewStyle>;
}

export const Divider: React.FC<DividerProps> = ({ style }) => {
  const { colors } = useTheme();
  return (
    <View style={[styles.divider, { backgroundColor: colors.border }, style]} />
  );
};

const styles = StyleSheet.create({
  divider: {
    height: 1,
    marginVertical: 8,
  },
});
